import React from "react";

export function Button({ children, variant = "solid", size = "md", className = "", ...props }) {
  const baseClass = "rounded-full font-semibold transition-all duration-300 inline-flex items-center justify-center";

  const sizeClass = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-6 py-3 text-lg",
    xl: "px-8 py-4 text-xl"
  }[size] || "px-4 py-2 text-base";

  const hasManagedStyle = className.includes("primary-action") || className.includes("secondary-action");
  const variantClass = hasManagedStyle
    ? ""
    : variant === "outline"
      ? "border border-slate-600 text-slate-300 hover:bg-slate-800 hover:border-cyan-500/50"
      : "bg-cyan-500 text-slate-950 hover:bg-cyan-300";

  return (
    <button className={`${baseClass} ${sizeClass} ${variantClass} ${className}`} {...props}>
      {children}
    </button>
  );
}
